/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import P from './P';
import H1 from './H1';
import H2 from './H2';
import H3 from './H3';
import H4 from './H4';
import H5 from './H5';

const typeMap = {
  paragraph: P,
  heading1: H1,
  heading2: H2,
  heading3: H3,
  heading4: H4,
  heading5: H5,
};

const RichText = ({ content, options }) => (
  <>
    {content.map((part, i) => {
      const Component = typeMap[part.type];
      const props = options[part.type];

      if (!Component) {
        return <P>Not implemented type: {part.type}</P>;
      }

      return (
        <Component key={`${part.type}-${i}`} {...props}>
          {part.text}
        </Component>
      );
    })}
  </>
);

RichText.defaultProps = {
  options: {},
};

RichText.propTypes = {
  content: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  options: PropTypes.shape({}),
};

export default RichText;
